import { createAction, props } from '@ngrx/store';
import { IBrand } from '../models/brands.models';
import { ITag } from '../models/tags.models';
import { APIResponse } from 'src/app/core/models/api-response';
import { ICategory } from '../models/catagories.models';
import { IObjectCustomFields, IObjectCustomFieldsParams } from '../models/custom-fields.models';

export const SetLoading = createAction(
  '[ Shared ] -  Set Loading page',
  props<{ isAppLoading: boolean }>()
);

export const SetCurrentElementId = createAction(
  '[ Shared ] -  Set CurrentElemnet Id',
  props<{ currentElementId?: number }>()
);

// fetch all brands
export const FetchAllBrands = createAction('[ Brands ] - FetchAllBrands');
export const FetchAllBrandsSuccess = createAction(
  '[ Brands ] - FetchAllBrands Success ',
  props<{ brands: IBrand[] }>()
);
export const FetchAllBrandsError = createAction('[ Brands ] - FetchAllBrand Error');

// fetch all tags
export const FetchAllTags = createAction('[ Tags ] - FetchAllTags');
export const FetchAllTagsSuccess = createAction(
  '[ Tags ] - FetchAllTags Success ',
  props<{ tags: ITag[] }>()
);
export const FetchAllTagsError = createAction('[ Tags ] - FetchAllTag Error');

// fetch all categories
export const FetchAllCategories = createAction('[ Categories ] - FetchAllCategories');
export const FetchAllCategoriesSuccess = createAction(
  '[ Categories ] - FetchAllCategories Success ',
  props<{ categories: APIResponse<ICategory> }>()
);
export const FetchAllCategoriesError = createAction('[ Categories ] - FetchAllCategories Error');

// language actions
export const SetLanguage = createAction(
  '[ Language ] - SetLanguage',
  props<{ language: string }>()
);

// Get Object Custom Fields
export const GetObjectCustomFields = createAction('[ Object Custom Fields ] - GetObjectCustomFields', props<{ params: IObjectCustomFieldsParams }>());
export const GetObjectCustomFieldsSuccess = createAction(
  '[ Object Custom Fields ] - GetObjectCustomFields Success ',
  props<{ objectCustomFields: IObjectCustomFields }>()
);
export const GetObjectCustomFieldsError = createAction('[ Object Custom Fields ] - GetObjectCustomFields Error');

// Update Object Custom Fields values
export const UpdateObjectCustomFields = createAction(
  '[ Object Custom Fields ] - UpdateObjectCustomFields',
  props<{ params: IObjectCustomFieldsParams; values: IObjectCustomFields['values'] }>()
);
export const UpdateObjectCustomFieldsSuccess = createAction(
  '[ Object Custom Fields ] - UpdateObjectCustomFields Success ',
  props<{ objectCustomFields: IObjectCustomFields }>()
);
export const UpdateObjectCustomFieldsError = createAction('[ Object Custom Fields ] - UpdateObjectCustomFields Error');

// Custom Fields Loader Actions
export const SetCustomFieldsLoader = createAction(
  '[ Custom Fields ] - SetLoading',
  props<{ isLoading: boolean }>()
);
